import React from 'react'
import Subheader from '../../component/Subheader'
import WeddingSlider from '../wedding/WeddingSlider'
import MeetingBigimage from './MeetingBigimage'
import MeetingAbout from './MeetingAbout'
import MeetingValue from './MeetingValue'
import WeddingStory from '../wedding/WeddingStory'
import MeetingTeambuild from './MeetingTeambuild'

export default function Meeting() {
  const subheadData = {
    heading: 'Meetings & Events Venues in Corbett',
    breadcrumb: [
      {
        slug: "/resort-de-coracao-corbett",
        name: "Jim Corbett",
      },
      {
        slug: "",
        name: "Meetings & Events",
      },
    ]
  }


  const slideData = {
    newClass: "meetpage-event",
    heading: "All Types of Corporate Events",
    slides: [
      {
        image: "/image/meeting-slide-1.webp",
        title: "Leadership <br /> Summits",
        desc: "A focused gathering of senior leaders to align vision, strengthen strategy, and drive organizational growth."
      },
      {
        image: "/image/meeting-slide-2.webp",
        title: "Corporate Award <br /> Nights",
        desc: "A formal celebration recognizing achievements, performance excellence, and organizational milestones in a refined setting."
      },
      {
        image: "/image/meeting-slide-3.webp",
        title: "Executive <br /> Retreats",
        desc: "A private offsite for strategic planning, leadership alignment, focused collaboration, and decision-making."
      },
      {
        image: "/image/meeting-slide-4.webp",
        title: "Corporate <br /> Exhibitions",
        desc: "A curated showcase for products, services, and industry engagement, networking, and brand visibility."
      },
    ]
  }


  const storyData = {
    title: "Where corporate goals meet the wild, transforming standard meetings into impactful and refreshing professional experiences.",
    description: "Discover a venue where productivity thrives amidst the raw beauty of the jungle. Nestled in Jim Corbett National Park, De Coracao Jim Corbett offers a distinctive setting designed to inspire your team through a seamless blend of professional facilities and natural serenity. Featuring a versatile event space spanning 2050 sq. ft. with a capacity to host up to 200 guests, the resort is ideal for executive retreats, corporate conferences, and business gatherings, elevated by thoughtful hospitality and effortless support.",
  }


  const bigImage = {
    image: "/image/corbett-meet-bigimage.webp",
  }


  const meetAbout = {
    para: "Break away from the traditional boardroom and step into an environment designed for meaningful collaboration. Surrounded by the calming sounds of the forest, your team can move effortlessly from productive sessions to curated outdoor experiences. The venue accommodates up to 200 guests in theatre style, 110 in cluster seating, and 60 in U-shape arrangements for perfect corporate gatherings.",
    image1: "/image/corbett-meetabout-1.webp",
    image2: "/image/corbett-meetabout-2.webp",
  }


  const meetValue = {
    title: "Added Values",
    para: "With a commitment to thoughtful hospitality and seamless execution, De Coracao Resort offers more than a venue — it delivers an experience aligned with your business objectives. Allow our team to manage every detail, so you can focus on strengthening relationships and driving meaningful outcomes.",
    image: "/image/corbett-meetvalue-image.webp",
    list: [
      "Diverse Dining Venues: Multiple indoor and outdoor settings offering tailored culinary experiences for corporate lunches or social galas.",
      "Curated Evening Lounges: Exclusive spaces designed for refined networking moments and relaxed post-meeting discussions.",
      "Innovative Team-Building: A range of jungle-centric activities specifically designed to enhance team engagement and morale.",
      "Dedicated Event Coordinator: On-site professional support ensuring every detail of your conference or meeting is executed flawlessly.",
    ]
  }


  const teamBuild = {
    leftImage: "/image/meetteam-image.webp",
    leftTitle: "TEAM-BUILDING <br/> EXPERIENCES",
    subtitle: "Team-Building Experiences",
    slides: [
      {
        title: "Jungle Survival Challenge",
        image: "/image/corbett-meetteam-slider-1.webp",
        desc: "Test your team’s communication and problem-solving skills with interactive outdoor simulations that require group synergy to navigate the unique landscape of Corbett."
      },
      {
        title: "Wilderness Scavenger Hunt",
        image: "/image/corbett-meetteam-slider-2.webp",
        desc: "A high-energy competition through our landscaped grounds that encourages agility and teamwork while immersing participants in the vibrant local atmosphere."
      }
    ]
  };

  return (
    <>
      <Subheader subheadData={subheadData} />
      <WeddingStory data={storyData} />
      <MeetingBigimage bigImage={bigImage} />
      <MeetingAbout meetAbout={meetAbout} />
      <MeetingValue meetValue={meetValue} />
      <WeddingSlider data={slideData} isBtn={false} />
      <MeetingTeambuild teamBuild={teamBuild} />
    </>
  )
}
